import { createSelector } from '@reduxjs/toolkit';

import type { FilesFileSchemaWithId } from '@iconik-io/iconik-api/src/services/files';

import { createEntitiesIndexSelector } from '../../entities_index/selectors';
import { selectFormatsByAssetId } from './formats';

export const selectFilesByAssetId = createEntitiesIndexSelector(
  'files',
  'asset_id',
);

export const selectFilesByFileSetId = createEntitiesIndexSelector(
  'files',
  'file_set_id',
);

export const selectOriginalFilesByVersionIdMap = createSelector(
  [selectFilesByAssetId, selectFormatsByAssetId],
  (files, formats) => {
    const originalFormatIds = new Set(
      formats
        .filter((format) => format.name?.toUpperCase() === 'ORIGINAL')
        .map((format) => format.id),
    );
    const result: Record<string, FilesFileSchemaWithId> = {};

    for (const file of files) {
      if (
        file.version_id &&
        file.format_id &&
        originalFormatIds.has(file.format_id)
      ) {
        result[file.version_id] = file;
      }
    }
    return result;
  },
);
